class BiddingType {
    constructor(serverType) {
        this.serverType = serverType;
    }

    translate(t) {
        return t(`auctions.bidding-type.${this.serverType.toLowerCase().replace(/_/g, '-')}`);
    }

    is(biddingType) {
        return biddingType === this;
    }
}

export const SLOTTED = new BiddingType('SLOTTED');
export const OPEN = new BiddingType('OPEN');
export const UNKNOWN = new BiddingType('null');

export const getBiddingType = (serverType) => {
    let result;
    switch (serverType) {
        case 'SLOTTED':
            result = SLOTTED;
            break;
        case 'OPEN':
            result = OPEN;
            break;
        default:
            result = UNKNOWN;
    }
    return result;
};

export const getAllBiddingTypes = () => [
    SLOTTED,
    OPEN,
];
